import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { lazyInject } from '@intelingu/core/IoC/container';
import { CardStore } from '@intelingu/core/stores/CardStore';

export interface LoadingIndicatorProps {
}

@observer export class LoadingIndicator extends Component<LoadingIndicatorProps, any> {

    @lazyInject(CardStore) cardStore: CardStore;

    render() {
        if (!this.cardStore.isLoading) {
            return null;
        }

        return <div className="lds-dual-ring" />
    }

}
